const footerColumns = [
  {
    title: '逛瓜',
    links: [
      { label: '事件流', href: '#stream' },
      { label: '持续跟进', href: '#followup' },
      { label: '热榜', href: '#hot' },
      { label: '本周大瓜', href: '#stream' },
    ],
  },
  {
    title: '分类',
    links: [
      { label: '情感', href: '#stream' },
      { label: '影视', href: '#stream' },
      { label: '音乐', href: '#stream' },
      { label: '综艺', href: '#stream' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '速报介绍', href: '#top' },
      { label: '跟进规则', href: '#followup' },
      { label: '订阅速报', href: '#subscribe' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-6">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-foreground-950 flex items-center justify-center">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl tracking-wide text-background-50">瓜圈速报</span>
            </div>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-xs">
              很多瓜不是一次就能吃透。我们保持持续跟进，最新回应、后续进展、反转更新都汇总在一起，有头有尾地摆着看。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#subscribe" aria-label="订阅" className="w-9 h-9 rounded-full bg-primary-900 hover:bg-primary-800 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-mail-send-line text-base"></i>
              </a>
              <a href="#stream" aria-label="事件流" className="w-9 h-9 rounded-full bg-primary-900 hover:bg-primary-800 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-radar-line text-base"></i>
              </a>
              <a href="#hot" aria-label="热榜" className="w-9 h-9 rounded-full bg-primary-900 hover:bg-primary-800 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-fire-line text-base"></i>
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-sm font-semibold text-accent-400 tracking-wider">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">© 2026 瓜圈速报 · 娱乐资讯聚合，内容为演示用途</p>
          <p className="text-xs text-background-400 flex items-center gap-2">
            <i className="ri-shield-check-line"></i>
            理性吃瓜，不信谣不传谣
          </p>
        </div>
      </div>
    </footer>
  );
}